// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__ib5AG","hov":"Footer_hov__ccJOT"};